import { useEffect, useState } from "react";

import { IconButton } from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

import useAuth from "../../hooks/useAuth";
import { DISPLAYING_FOR } from "../../config/AppEnums";

import "./css/likes-is-done.css";

import { likeDislike, doubtSolved, answerWorked } from "../../functions/server-requests/utils";

const LikesIsDone = ({ displayingFor, displayingForId, likedBy, likes, isDone, isUserAuthenticated }) => {
  const { auth } = useAuth();
  const [likesDisplaying, setLikesDisplaying] = useState(likes);
  const [isShowOutlinedLikeIcon, setShowOutlinedLikeIcon] = useState(true);
  const [isShowOutlinedDoneIcon, setShowOutlinedDoneIcon] = useState(!isDone);
  const [isSubmitting, setSubmitting] = useState(false);

  useEffect(() => {
    setShowOutlinedLikeIcon(!(auth.isLoggedIn && likedBy.findIndex(likedBy => likedBy.likedById === auth.userId) > -1));
  }, [auth.isLoggedIn]);

  const handleLikeDislike = async () => {
    setSubmitting(true);

    const likeDislikeRes = await likeDislike({
      likedOrNot: false,
      ldFor: displayingFor,
      ldForId: displayingForId,
      ldById: auth.userId
    });

    if (likeDislikeRes.status === 201) {
      setLikesDisplaying(likeDislikeRes.data.likes);
      setShowOutlinedLikeIcon(likeDislikeRes.data.isLiked ? false : true);
    }

    setSubmitting(false);
  }

  const handleIsDone = async () => {
    setSubmitting(true);

    const res =
      displayingFor === DISPLAYING_FOR.DOUBT
        ? await doubtSolved({ doubtId: displayingForId })
        : await answerWorked({ answerId: displayingForId });

    if (res.status === 201) {
      setShowOutlinedDoneIcon(!isShowOutlinedDoneIcon);
    }

    setSubmitting(false);
  }

  const likeIconStyles = { color: "#dc2626" };
  const doneIconStyles = { color: "#059669" };

  return (
    <div
      className="lis-data"
      style={{ justifyContent: displayingFor !== DISPLAYING_FOR.HOME ? "flex-end" : "" }}
    >
      {auth.isLoggedIn
        ? <>
          <IconButton
            onClick={handleLikeDislike}
            disabled={isSubmitting}
          >
            {isShowOutlinedLikeIcon
              ? <ThumbUpOutlinedIcon style={likeIconStyles} />
              : <ThumbUpIcon style={likeIconStyles} />
            }
          </IconButton>
          {likesDisplaying}
        </>
        : <div className="lis-likes">
          <ThumbUpOutlinedIcon style={likeIconStyles} />&nbsp;
          {likes}
        </div>
      }

      {/* ------------------------------------------------------------ */}

      {((isDone && !isUserAuthenticated) || displayingFor === DISPLAYING_FOR.HOME) &&
        <div className="lis-is-solved">
          {isShowOutlinedDoneIcon
            ? <CheckCircleOutlinedIcon style={doneIconStyles} />
            : <CheckCircleIcon style={doneIconStyles} />
          }
        </div>
      }

      {(isUserAuthenticated && displayingFor !== DISPLAYING_FOR.HOME) &&
        <IconButton
          sx={{ marginLeft: "20px" }} // refer ".lis-is-solved" class in likes-is-solved.css
          onClick={handleIsDone}
          disabled={isSubmitting}
        >
          {isShowOutlinedDoneIcon
            ? <CheckCircleOutlinedIcon style={doneIconStyles} />
            : <CheckCircleIcon style={doneIconStyles} />
          }
        </IconButton>
      }
    </div>
  );
}

export default LikesIsDone;